/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DeleteLeadAssignment200Response
 */
export interface DeleteLeadAssignment200Response {
    /**
     * 
     * @type {object}
     * @memberof DeleteLeadAssignment200Response
     */
    data: object;
}

/**
 * Check if a given object implements the DeleteLeadAssignment200Response interface.
 */
export function instanceOfDeleteLeadAssignment200Response(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "data" in value;

    return isInstance;
}

export function DeleteLeadAssignment200ResponseFromJSON(json: any): DeleteLeadAssignment200Response {
    return DeleteLeadAssignment200ResponseFromJSONTyped(json, false);
}

export function DeleteLeadAssignment200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeleteLeadAssignment200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': json['data'],
    };
}

export function DeleteLeadAssignment200ResponseToJSON(value?: DeleteLeadAssignment200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data,
    };
}

